
import { Vue, Component } from 'vue-property-decorator';
// import RankList from './components/RankList.vue';
import { Eventbus } from '../bus';
import {
  getlist,
  getScore,
  getOneRank,
  getRankList,
  getUserInfo,
} from '../api/index';
import { Toast } from 'vant';
import qs from 'qs';
import { getVoteList } from '../../../api/api';
Vue.use(Toast);
@Component
export default class Home extends Vue {
  initVal: boolean = true; // 初始进来
  quizTime: boolean = false; // 答题中
  answerTime: number = 0; // 答题时间
  timer: any = null;
  allQuestion: any = [];
  currentIndex: number = 0; // 当前答题的题目索引
  allAnswer: any = [];
  answerIsTrue: boolean = false;
  answerTip: string = ''; // 当前答案提示
  finishPopupVal = false;
  isClicked: boolean = false;
  currentTrueAnswer: string = ''; // 当前正确答案
  currentClickedIndex: number = -1; // 当前点击答案索引、
  oneRankData: any = {}; // 答题信息
  onlyId: any = ''; // 当前答题的唯一标识，防止中途退出数据混乱
  userData: any = {}; // 当前用户信息
  defaultImg = require('../assets/default.png');
  totalScore = ''; // 总分
  answer: any[] = [];
  answerString = '';

  // 显示答题时间
  get showAnswerTime() {
    return this.transformDate(this.answerTime);
  }

  // 所有题目的id
  get allQuestionId() {
    return this.allQuestion && this.allQuestion.map((item: any) => item.id);
  }

  get allQuestionAnswer() {
    return (
      this.allQuestion && this.allQuestion.map((item: any) => item.answer_true)
    );
  }
  async created() {
    // 监听当点击index页面的时候,所有状态为初始状态
    Eventbus.$on('toIndexPage', () => {
      this.initVal = true;
      this.quizTime = false;
      this.answerTime = 0;
      this.allQuestion = [];
      this.currentIndex = 0;
      this.allAnswer = [];
      this.answerIsTrue = false;
      this.answerTip = '';
      this.finishPopupVal = false;
      this.isClicked = false;
      this.currentTrueAnswer = '';
      this.currentClickedIndex = -1;
      this.oneRankData = {};
      this.onlyId = '';
      clearInterval(this.timer);
    });
    // 当登录的时候重新请求数据函数
    window.userInfoChange = () => {
      getlist().then((res: any) => {
        this.oneRankData = res;
      });
    };
    getUserInfo().then((res: any) => {
      if (res.code === 200) {
        this.userData = res.data;
        console.log('用户信息', res);
      }
    });
    const res = await getlist();
    this.oneRankData = res;
    this.judgeLogin(res);
  }
  // 获取题目
  async getQuestion() {
    const ret: any = await getlist();
    this.judgeLogin(ret);
    if (ret.code === 315) {
      Toast.fail('今日答题已完成');
      setTimeout(() => {
        this.showRankListBtn();
      }, 500);

      return;
    }
    if (ret.code === 200) {
      this.allQuestion = ret.data;
      console.log('所有问题', this.allQuestion);
      this.initVal = false;
      this.quizTime = true;
      this.onlyId = Date.now();
      this.allAnswer = this.filterAnswer(ret.data);
      console.log('所有答案', this.allAnswer);
    } else {
      Toast.fail(ret.msg);
    }
  }
  // 查看排行榜按钮
  async showRankListBtn() {
    // const isLogin = await this.judgeLogin(this.oneRankData);
    // if (!isLogin) {
    //   return;
    // }
    this.$router.go(0);
    // this.$router.push({
    //   path: 'home',
    // });
    // this.finishPopupVal = false;
    // this.initVal = false;
    // this.quizTime = false;
    return false;
  }
  // 开始答题
  startAction() {
    const hours = new Date().getHours();
    if (hours < 7 || hours > 21) {
      Toast.fail('请在每天7-22点之间答题');
      return false;
    }
    this.getQuestion();
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.answerTime++;
    }, 1000);
  }
  // 筛选答案
  filterAnswer(arr: any) {
    return arr.map((item: any) => {
      const temp: any = [];
      if (item.answer_a) {
        temp.push({
          value: 'A',
          text: item.answer_a,
        });
      }
      if (item.answer_b) {
        temp.push({
          value: 'B',
          text: item.answer_b,
        });
      }
      if (item.answer_c) {
        temp.push({
          value: 'C',
          text: item.answer_c,
        });
      }
      if (item.answer_d) {
        temp.push({
          value: 'D',
          text: item.answer_d,
        });
      }
      return temp;
    });
  }
  // 选择答案
  chooseAnswer(val: any, index: number) {
    this.currentClickedIndex = index;
    this.currentTrueAnswer = this.allQuestionAnswer[this.currentIndex];
    if (this.answer.indexOf(val) !== -1) {
      this.answer.splice(this.answer.indexOf(val), 1);
    } else {
      this.answer.push(val);
    }

    this.answer.sort();
    this.answerString = '';
    this.answer.map((item: string) => {
      this.answerString += item;
    });
    console.log(this.currentTrueAnswer);
  }
  // 提交答案
  async submitAnswer(val: any, index: number) {
    if (!this.answer.length) {
      Toast.fail('请选择答案');
      return;
    }
    if (this.isClicked) {
      Toast.fail('本题已答题，请选择下一题');
      return;
    }
    // 判断对错
    if (this.currentTrueAnswer === this.answerString) {
      // this.answerIsTrue = true;
      Toast({
        type: 'success',
        message: '回答正确',
        duration: 800,
      });
    } else {
      this.answerIsTrue = true;
      Toast({
        type: 'fail',
        message: '回答错误',
        duration: 800,
      });
    }
    this.isClicked = true;
    const state = this.currentIndex === 9 ? 2 : this.currentIndex === 0 ? 0 : 1;
    let totalTime = 0;
    if (state === 2) {
      totalTime = this.answerTime;
      clearInterval(this.timer);
    }
    const id = this.allQuestionId[this.currentIndex];
    const isTrue = this.answerString;
    const res = await getScore(
      state,
      JSON.stringify(this.allQuestionId),
      id,
      isTrue,
      this.onlyId,
      totalTime,
    );
    await this.handleSubmitData(res.data);
  }
  // 处理提交后的答案
  handleSubmitData(data: any) {
    this.answerTip = data.content;
    this.totalScore = data.score;
    // this.currentTrueAnswer = data.answer_true;
    if (data.correct === false) {
      // this.answerIsTrue = true;
      console.log('当前索引', this.currentIndex);
    }
    if (data.correct === true) {
      this.isClicked = false;
      // 判断当前索引 为最后一题直接返回
      console.log('当前索引', this.currentIndex);
      if (!this.judgeOverAction(2)) {
        return;
      }
      setTimeout(() => {
        this.answer = [];
        this.answerString = '';
        this.currentIndex++;
      }, 800);
    }
  }
  // 点击下一题
  nextQuestion() {
    if (!this.isClicked) {
      Toast.fail('请提交答案');
      return;
    }
    // 判断当前索引 为最后一题直接返回
    if (!this.judgeOverAction(9)) {
      return;
    }

    this.isClicked = false;
    this.answerTip = '';
    this.answerIsTrue = false;
    this.currentTrueAnswer = '';
    this.currentClickedIndex = -1;
    this.currentIndex++;
    this.answer = [];
    this.answerString = '';
  }
  // 判断答题是否完毕
  judgeOverAction(data: any) {
    if (this.currentIndex === 9) {
      // this.quizTime = false;
      this.finishPopupVal = true;
      console.log('答题完毕！');
      clearInterval(this.timer);
      return false;
    } else {
      return true;
    }
  }
  // 判断是否登陆
  async judgeLogin(res: any) {
    console.log('judge login');
    if (res.code === 203) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return false;
    }
    return true;
  }
  // 转换时间
  transformDate(t: any) {
    return `${Math.floor(t / 60)} '${((t % 60) / 100).toFixed(2).slice(-2)}"`;
  }
}
